import React, { useState } from "react";
import { FaGoogle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../config";
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";

import app_logo from "../icons/app_logo.svg";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleAuth = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/home");
    } catch (err) {
      switch (err.code) {
        case "auth/user-not-found":
          setErrorMessage("Осы электрондық поштасы бар пайдаланушы табылмады.");
          break;
        case "auth/wrong-password":
          setErrorMessage("Қате құпия сөз.");
          break;
        default:
          setErrorMessage("Қате орын алды. Қайталап көріңіз.");
      }
    }
  };

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        displayName: user.displayName,
        email: user.email,
        photoURL: user.photoURL,
        lastLogin: new Date(),
      }, { merge: true });
      navigate("/home");
    } catch (err) {
      console.error("Google кіру қатесі:", err);
    }
  };

  return (
    <div className="w-full max-w-md p-8 rounded-3xl bg-white/30 backdrop-blur-xl shadow-xl border border-white/20">

      <div className="flex justify-center mb-6">
        <img src={app_logo} alt="app_logo" className="h-16 w-16 object-contain" />
      </div>

      <h2 className="text-2xl font-semibold text-center text-gray-800">Аккаунтқа кіру</h2>

      {errorMessage && <p className="text-red-500 text-center mt-2">{errorMessage}</p>}

      <form onSubmit={handleAuth} className="mt-6 space-y-4">
        <input
          type="email"
          placeholder="Электрондық пошта"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-3 rounded-xl bg-white/60 backdrop-blur-md placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-[#3C78F9] border border-white/20"
          required
        />
        <input
          type="password"
          placeholder="Құпия сөз"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-3 rounded-xl bg-white/60 backdrop-blur-md placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-[#3C78F9] border border-white/20"
          required
        />

        <div className="flex justify-end">
          <a href="/" className="text-sm text-[#E68F5A] hover:underline">Құпия сөзді ұмыттыңыз ба?</a>
        </div>

        <button
          type="submit"
          className="w-full bg-[#3C78F9] text-white p-3 rounded-xl font-semibold hover:bg-[#2A5ECB] transition-all"
        >
          Кіру
        </button>
      </form>

      <div className="text-center mt-6 text-gray-700">Немесе</div>

      <div className="flex justify-center mt-4">
        <button
          onClick={handleGoogleSignIn}
          className="flex items-center gap-2 px-6 py-3 bg-[#E68F5A] text-white rounded-xl font-semibold shadow-md hover:bg-[#D1774A] transition-all"
        >
          <FaGoogle size={20} /> Google арқылы кіру
        </button>
      </div>

      <div className="text-center mt-6 text-gray-700">
        Аккаунтыңыз жоқ па? <a href="/register" className="text-[#E68F5A] font-semibold hover:underline">Тіркелу</a>
      </div>
    </div>
  );
};

export default Login;